<sui-dialog-simple [(error)]="apiError">
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>
      {{ "move-user-company.title.move-user-to-another-company" | translate }}
    </h2>

    <sui-button
      size="sm"
      variant="danger"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="plan-execute">
      <sui-detail-list class="move-user-company__facts">
        <sui-detail-item [label]="'move-user-company.label.user' | translate"
          ><span class="move-user-company__name">{{ user.display_name }}</span>
          <span class="move-user-company__email">{{
            user.email
          }}</span></sui-detail-item
        >
        <sui-detail-item
          [label]="'move-user-company.label.current-company' | translate"
          >{{ user.company_name }}</sui-detail-item
        >
      </sui-detail-list>

      <sui-form-field>
        <label sui-label for="move-user-company-target">
          {{ "move-user-company.label.target-company" | translate }}
        </label>
        <sui-combobox
          [id]="'move-user-company-target'"
          [formControl]="targetCompanyControl"
          [options]="companyOptions()"
          [loading]="companiesLoading()"
          [placeholder]="
            'move-user-company.placeholder.select-a-company' | translate
          "
        ></sui-combobox>
      </sui-form-field>

      @if (report(); as report) {
        <section class="plan-execute__section">
          <h4 class="plan-execute__heading">
            {{ "move-user-company.section.owned-objects" | translate }}
          </h4>
          @if (ownedObjectRows().length > 0) {
            <div class="review-table-wrap review-table-wrap--compact">
              <table class="review-table">
                <thead>
                  <tr>
                    <th>
                      {{ "move-user-company.column.object-class" | translate }}
                    </th>
                    <th class="review-table__num">
                      {{ "move-user-company.column.active" | translate }}
                    </th>
                    <th class="review-table__num">
                      {{ "move-user-company.column.archived" | translate }}
                    </th>
                    <th class="review-table__num">
                      {{ "move-user-company.column.deleted" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of ownedObjectRows(); track row.key) {
                    <tr>
                      <td class="review-table__name">
                        {{
                          "move-user-company.class." + row.labelKey | translate
                        }}
                      </td>
                      <td class="review-table__num">{{ row.active }}</td>
                      <td class="review-table__num">{{ row.archived }}</td>
                      <td class="review-table__num">{{ row.deleted }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="plan-execute__lead">
              {{ "move-user-company.text.no-owned-objects" | translate }}
            </p>
          }
        </section>

        <section class="plan-execute__section">
          <h4 class="plan-execute__heading">
            {{ "move-user-company.section.housekeeping" | translate }}
          </h4>
          <ul class="plan-execute__list">
            <li>
              {{
                "move-user-company.warning.sessions-signed-out"
                  | translate: { count: report.warnings.sessions }
              }}
            </li>
            <li>
              @if (report.warnings.groups.length > 0) {
                {{
                  "move-user-company.warning.groups-left"
                    | translate: { groups: groupsLeft() }
                }}
              } @else {
                {{ "move-user-company.warning.no-groups-left" | translate }}
              }
            </li>
            <li>
              {{
                "move-user-company.warning.roles-dropped-kept"
                  | translate
                    : {
                        dropped: report.warnings.roles_dropped.length,
                        kept: report.warnings.roles_kept.length,
                      }
              }}
            </li>
            <li>
              {{
                "move-user-company.warning.invisible-shares"
                  | translate: { count: report.warnings.invisible_shares }
              }}
            </li>
            <li>
              {{
                "move-user-company.warning.rules-left-behind"
                  | translate: { count: report.warnings.left_behind.rule }
              }}
            </li>
          </ul>
        </section>

        @if (report.requires_new_owner) {
          <section class="plan-execute__section">
            <h4 class="plan-execute__heading">
              {{ "move-user-company.section.new-owner" | translate }}
            </h4>
            <p class="plan-execute__lead">
              {{ "move-user-company.text.new-owner-required" | translate }}
            </p>
            <div class="move-user-company__owner">
              @if (newOwner(); as owner) {
                <span class="move-user-company__owner-name">
                  {{ owner.name }}
                  @if (owner.email) {
                    <span class="move-user-company__email">{{
                      owner.email
                    }}</span>
                  }
                </span>
              } @else {
                <span class="plan-execute__lead">
                  {{ "move-user-company.text.no-owner-chosen" | translate }}
                </span>
              }
              <sui-button
                size="sm"
                variant="secondary"
                [leadingIcon]="['fas', 'user']"
                [disabled]="!!outcome()"
                (click)="chooseNewOwner()"
              >
                {{ "move-user-company.button.choose" | translate }}
              </sui-button>
            </div>
          </section>
        }
      }

      @if (outcome(); as outcome) {
        <section
          class="plan-execute__results"
          [class.plan-execute__results--failed]="!executed()"
        >
          <h4 class="plan-execute__heading">
            {{
              (executed()
                ? "move-user-company.result.user-moved"
                : "move-user-company.result.move-failed"
              ) | translate
            }}
          </h4>
          @if (outcome.report.results; as results) {
            <p>
              {{
                "move-user-company.result.applied-skipped-failed"
                  | translate
                    : {
                        applied: results.applied,
                        skipped: results.skipped,
                        failed: results.failed,
                      }
              }}
            </p>
            @if (results.failures.length > 0) {
              <ul class="plan-execute__list">
                @for (failure of results.failures; track failure.action_id) {
                  <li>
                    <span class="plan-execute__failure-object">{{
                      failure.object_id
                    }}</span>
                    {{ failure.reason }}
                  </li>
                }
              </ul>
            }
          }
        </section>
      }
    </div>
  </ng-template>

  <ng-template suiDialogFooter>
    @if (!outcome()) {
      <sui-button size="md" variant="secondary" (click)="cancel()">
        {{ "btn.cancel" | translate }}
      </sui-button>
      @if (!report()) {
        <sui-button
          size="md"
          variant="primary"
          [disabled]="!canPlan()"
          [loading]="planMutation.isPending()"
          (click)="plan()"
        >
          {{ "move-user-company.button.plan" | translate }}
        </sui-button>
      } @else {
        <sui-button
          size="md"
          variant="primary"
          [leadingIcon]="['fas', 'exchange-alt']"
          [disabled]="!canMove()"
          [loading]="executeMutation.isPending()"
          (click)="move()"
        >
          {{ "move-user-company.button.move" | translate }}
        </sui-button>
      }
    } @else {
      <sui-button size="md" variant="primary" (click)="finish()">
        {{ "btn.close" | translate }}
      </sui-button>
    }
  </ng-template>
</sui-dialog-simple>
